import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeEducationListService = ({
  employeeId,
  ...rest
}: {
  employeeId: number;
  page?: number;
  limit?: number;
  courseName?: string;
  formOfTraining?: string;
  finalResult?: string;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.EmployeeEducation>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{employeeId}", String(employeeId)),
    config: {
      requireAuthentication: true,
      params: rest,
    },
  });

export const employeeEducationCreateService = ({
  employeeId,
  ...rest
}: {
  employeeId: number;
  courseName: string;
  courseContent?: string;
  fromDate?: string;
  toDate?: string;
  timeOfTraining?: number;
  formOfTraining?: string;
  trainingCenter?: string;
  methodOfTraining?: string;
  levelOfTraining?: string;
  finalResult?: string;
  attachments?: string[];
  coursePrice?: number;
  note?: string;
}) =>
  RestAPIClient.call<Types.EmployeeEducation>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{employeeId}", `${employeeId}`),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const employeeEducationUpdateService = ({
  id,
  employeeId,
  ...rest
}: Parameters<typeof employeeEducationCreateService>[0] & { id: string }) =>
  RestAPIClient.call<Types.EmployeeEducation>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update.replace("{id}", id).replace(
      "{employeeId}",
      `${employeeId}`
    ),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const employeeEducationDeleteService = ({
  id,
  employeeId,
}: {
  id: string;
  employeeId: number;
}) =>
  RestAPIClient.call<Types.EmployeeEducation>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Delete.replace("{id}", id).replace(
      "{employeeId}",
      `${employeeId}`
    ),
    config: {
      requireAuthentication: true,
    },
  });

export const employeeEducationDetailService = ({
  id,
  employeeId,
}: {
  id: string;
  employeeId: number;
}) =>
  RestAPIClient.call<Types.EmployeeEducation>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", id).replace(
      "{employeeId}",
      `${employeeId}`
    ),
    config: {
      requireAuthentication: true,
    },
  });
